import type { IndustryAccent } from "@/components/marketing";
import { industryPages, type IndustrySlug } from "../../data";
import { pageSEO } from "@/utils/seo.util";
import type { Metadata } from "next";

// Accent classes for the blocks this family draws itself (goal tracker,
// org chart, WhatsApp card, list markers). One tone pair per accent, as in
// the shared industry blocks: `soft` pale fill, `ink` strong text/fill,
// `border` accent outline, `softBorder` pale outline, `connector` the
// dotted org-chart lines (drawn with ::before), `marker` list bullet.
export const industryAccent: Record<
  IndustryAccent,
  {
    soft: string;
    ink: string;
    solid: string;
    border: string;
    softBorder: string;
    connector: string;
    marker: string;
  }
> = {
  brand: {
    soft: "bg-tone-peach",
    ink: "text-primary",
    solid: "bg-primary",
    border: "border-primary",
    softBorder: "border-tone-peach",
    connector: "before:border-primary",
    marker: "marker:text-primary",
  },
  mint: {
    soft: "bg-tone-mint",
    ink: "text-tone-mint-ink",
    solid: "bg-tone-mint-ink",
    border: "border-tone-mint-ink",
    softBorder: "border-tone-mint",
    connector: "before:border-tone-mint-ink",
    marker: "marker:text-tone-mint-ink",
  },
  lilac: {
    soft: "bg-tone-lilac",
    ink: "text-tone-lilac-ink",
    solid: "bg-tone-lilac-ink",
    border: "border-tone-lilac-ink",
    softBorder: "border-tone-lilac",
    connector: "before:border-tone-lilac-ink",
    marker: "marker:text-tone-lilac-ink",
  },
  sun: {
    soft: "bg-tone-sun",
    ink: "text-tone-sun-ink",
    solid: "bg-tone-sun-ink",
    border: "border-tone-sun-ink",
    softBorder: "border-tone-sun",
    connector: "before:border-tone-sun-ink",
    marker: "marker:text-tone-sun-ink",
  },
  sky: {
    soft: "bg-tone-sky",
    ink: "text-tone-sky-ink",
    solid: "bg-tone-sky-ink",
    border: "border-tone-sky-ink",
    softBorder: "border-tone-sky",
    connector: "before:border-tone-sky-ink",
    marker: "marker:text-tone-sky-ink",
  },
};

// `generateMetadata` for one industry page's folder.
export const industryPageMetadata = (slug: IndustrySlug): Promise<Metadata> => {
  const { seo } = industryPages[slug];
  return pageSEO(seo);
};
